
/* remove low and medium if needed */
const lowPriorityEntryPoints = document.querySelectorAll(".quiz-entry[data-display-priority='2']");
const mediumPriorityEntryPoints = document.querySelectorAll(".quiz-entry[data-display-priority='1']");
const highPriorityEntryPoints = document.querySelectorAll(".quiz-entry[data-display-priority='0']");

if (mediumPriorityEntryPoints.length > 0) {
  lowPriorityEntryPoints.forEach(l => {
    if (l.classList.contains('quiz-sticky-banner')) {
      closeBanner(l, false);
    } else {
      l.parentElement.removeChild(l);
    }
  });
}

if (highPriorityEntryPoints.length > 0) {
  mediumPriorityEntryPoints.forEach(m => {
    if (m.classList.contains('quiz-sticky-banner')) {
      closeBanner(m, false);
    } else {
      m.parentElement.removeChild(m);
    }

  });
}

/* end remove low and medium if needed */

/* handle rendering quiz */
let currentDeck = 0;

const quiz = document.querySelector('.quiz-modal');
const quizID = quiz.getAttribute('data-quiz-id');

const deckName = quiz.getAttribute('data-deck-name');
const trackingKey = deckName ?? 'quiz';

const deckCards = document.querySelectorAll('.deck-card') ?? [];

const entryPointButtons = document.querySelectorAll('.entry-point-btn') ?? [];
const multiSelectCheckboxes = document.querySelectorAll(".deck-card input[type='checkbox']") ?? [];
const multiSelectRadioButtons = document.querySelectorAll(".deck-card input[type='radio']") ?? [];
const progressButtons = document.querySelectorAll('.progress-btn') ?? [];
const closeButtons = document.querySelectorAll('.deck-card .quiz__close-btn') ?? [];

const extraModals = document.querySelectorAll('.deck-card .extra-modal .copy');

const forms = document.querySelectorAll(".deck-card form");

const formInputRules = {
  'text': v => v !== '',
  'email': validateEmail,
};

const formStates = {};

const initFormState = (form) => {
  const inputs = [...form.querySelectorAll('input')];

  const states = inputs.map(input => {
    const mappedValue = ({ isValid: false });

    if (input.getAttribute('data-validate-input') != null) {
      mappedValue['rule'] = formInputRules[input.type];
    }

    if (input.getAttribute('required') == null) {
      mappedValue['required'] = false;
      mappedValue['isValid'] = true;
    } else {
      mappedValue['required'] = true;
    }

    return mappedValue;
  });

  formStates[`${form.id}`] = [...states];

  inputs.forEach(i => i.value = '');
  updateForm(form);
}

const updateForm = (form) => {
  const formState = formStates[`${form.id}`];
  const progressButton = form.querySelector('.progress-btn');

  if (formState == null || progressButton == null) {
    return;
  }

  const completelyValidForm = formState.filter(s => s.required).find(s => !s.isValid) == null;

  if (completelyValidForm) {
    progressButton.classList.remove('disabled');
  } else {
    progressButton.classList.add('disabled');
  }
}

const resetDecks = () => {
  deckCards.forEach((card, index) => {
    card.classList.add('hidden');

    if (index === 0) {
      card.classList.remove('hidden');
    }

    const choices = card.querySelector(".choices[data-requires-choice]");
    if (choices != null) {
      card.querySelector('.progress-btn').classList.add('disabled');
    }
  });

  [...multiSelectCheckboxes, ...multiSelectRadioButtons].forEach(checkBox => {
    checkBox.checked = false;
  });

  forms.forEach(f => initFormState(f));

  currentDeck = 0;
}

const closeQuiz = () => {
  document.body.style.removeProperty('overflow');
  quiz.classList.add('hidden');

  trackQuizInteraction(quizID, `${trackingKey}_close_tapped`);

  resetDecks();
}

addEventListener('keyup', e => {
  if (quiz != null && !quiz.classList.contains('hidden') && e.key === 'Escape') {
    e.preventDefault();
    closeQuiz();
  }
});

entryPointButtons.forEach(entryPointButton => {
  entryPointButton.addEventListener('click', e => {
    e.preventDefault();

    trackQuizInteraction(quizID, `${trackingKey}_start_tapped`, [
      { key: "entry-text", value: entryPointButton.textContent }
    ]);

    document.body.style.overflow = 'hidden';
    document.activeElement.blur();
    quiz.classList.remove('hidden');
  });
});

forms.forEach(form => {
  const inputs = [...form.querySelectorAll('input')];
  const states = inputs.map(input => {
    const mappedValue = ({ isValid: false });

    if (input.getAttribute('data-validate-input') != null) {
      mappedValue['rule'] = formInputRules[input.type];
    }

    if (input.getAttribute('required') == null) {
      mappedValue['required'] = false;
      mappedValue['isValid'] = true;
    } else {
      mappedValue['required'] = true;
    }

    return mappedValue;
  });

  formStates[`${form.id}`] = [...states];

  inputs.forEach((input, i) => {
    const validateForm = (input) => {
      if (input == null) {
        return;
      }

      const value = input.value;

      const inputState = formStates[`${form.id}`][i];
      const { required, rule } = inputState;

      const closest = input.closest('.input-validation-wrapper');

      const errorElement = closest.querySelector('.error-wrapper');
      const graphic = closest.querySelector('.input-wrapper img');

      if (!required) {
        return;
      }

      if (input.type === 'checkbox') {
        inputState.isValid = input.checked;
      } else if (rule != null) {
        inputState.isValid = rule(value);

        if (inputState.isValid) {
          errorElement.classList.remove('shown');
          graphic.classList.add('hidden');
        } else {
          errorElement.classList.add('shown');
          graphic.classList.remove('hidden');
        }
      } else {
        inputState.isValid = input.value.length > 0;
      }

      formStates[`${form.id}`][i] = { ...inputState };
      updateForm(form);
    }

    input.addEventListener('blur', e => {
      e.preventDefault();
      validateForm(inputs[i]);
    })
    input.addEventListener('input', e => {
      e.preventDefault();
      validateForm(inputs[i]);
    });
  });
})

progressButtons.forEach(progressButton => {
  progressButton.addEventListener('click', async e => {
    e.preventDefault();

    const actionType = progressButton.getAttribute('data-action-type');

    switch (actionType) {
      case 'start':

        trackQuizInteraction(quizID, `${trackingKey}_started`);
        break;
      case 'finish':
        const quizCookieName = `quiz#${quizID}`;
        document.cookie = `${quizCookieName}=true;path=/`;

        document.body.style.removeProperty('overflow');
        quiz.classList.add('hidden');

        const entryPoint = document.querySelectorAll(`.quiz-entry[data-quiz-id='${quizID}']`);

        entryPoint.forEach(e => {
          if (e.classList.contains('top-banner')) {
            closeBanner(e);
          } else {
            e.parentElement.removeChild(e);
          }
        })

        trackQuizInteraction(quizID, `${trackingKey}_completed`);
        resetDecks();

        window.location = progressButton.getAttribute('href');
        break;
      case 'multi-answer':
        const inputs = progressButton.parentElement.querySelectorAll("input:checked");
        const selected = Array.from(inputs).map(i => i.parentElement.querySelector('label').textContent);
      
        trackQuizInteraction(quizID, `${trackingKey}_answer_tapped`, [
          { key: 'card', value: progressButton.getAttribute('data-card-rel') },
          { key: 'response', value: selected }
        ]);      
        updateStore({
          card: progressButton.getAttribute('data-card-rel'), response: selected.length > 0 ? selected[0] : null });
        break;
      case 'answer':
        trackQuizInteraction(quizID, `${trackingKey}_answer_tapped`, [
          { key: 'card', value: progressButton.getAttribute('data-card-rel') },
          { key: 'response', value: progressButton.textContent }
        ]);
        updateStore({
          card: progressButton.getAttribute('data-card-rel'), response: progressButton.textContent.trim() });
        break;

      case 'form':
        const form = progressButton.parentElement;
        const formData = new FormData(form);
      
        // Convert inputs into an object for updateStore
        const graphQLMappedInputs = {};
        formData.forEach((value, key) => {
          graphQLMappedInputs[key] = value === 'on' ? 'yes' : value; // Handle checkboxes
        });

        updateStore({
          quizId: quizID,
          formId: form.id,
          fullName: graphQLMappedInputs['full-name'],
          email: graphQLMappedInputs['email'],
          isUsCitizen: graphQLMappedInputs['is_us_citizen'],
          isNotMinor: graphQLMappedInputs['is_not_minor'],
          actionDetail: `${trackingKey}_form_submitted`
        });

        await sscmsFetchGraphQL(buildQuery(store));
        break;
    }

    if (!progressButton.classList.contains('disabled')) {
      deckCards[currentDeck].classList.add('hidden');
      deckCards[++currentDeck].classList.remove('hidden');
    }
  });
});

closeButtons.forEach(closeButton => {
  closeButton.addEventListener('click', e => {
    e.preventDefault();
    closeQuiz();
  });
});

const radioButtons = document.querySelectorAll("input[type='radio']");
radioButtons.forEach(radio => {
  radio.addEventListener('input', e => {
    radio.closest('.multi-select-wrapper').querySelector('.progress-btn').classList.remove("disabled");
  })
})

const cardExtras = document.querySelector('.card-extras');

if (cardExtras != null) {
  const expandables = cardExtras.querySelectorAll('.expandable') ?? [];
  const modals = cardExtras.querySelectorAll('.extra-modal-wrapper') ?? [];

  if (expandables.length > 0 && modals.length > 0) {
    expandables.forEach((expandable, index) => {
      expandable.addEventListener('click', e => {
        modals[index].classList.remove('hidden');
      })
    });

    modals.forEach((modal, index) => {
      const closeButton = modal.querySelector('.btn.btn--outline');
      closeButton.addEventListener('click', e => {
        modals[index].classList.add('hidden');
      });
    })
  }
}

extraModals.forEach(modal => {
  const anchors = [...modal.querySelectorAll('a')];

  anchors.forEach(anchor => {
    anchor.addEventListener('click', e => {
      e.preventDefault();
      const idPart = anchor.href.split('#')[1];
      const scrollToElement = modal.querySelector(`#${idPart}`);

      if (scrollToElement != null) {
        scrollToElement.scrollIntoView();
      }
    });
  })
})